import { isObjectEquals } from 'Common/utilities/objectValidation';

export const closeModalOnSave = ({ scope, modalInstance }) => () => {
  const isShowRecalculationModal = isObjectEquals(
    scope.insuranceProfilerSettings,
    scope.initialSettings,
  );
  return modalInstance.close(!isShowRecalculationModal);
};
